import APIClient from '@/shared/http/clients/api'

const resourceName = 'APRTemplateTipoRisco'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetRiscos = (aprId, revisao, etapaServico, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetRiscos/${aprId}/${revisao}/${etapaServico}`, data, config)

const aprTemplateRiskTypeRepository = {
  GetRiscos
}

export default aprTemplateRiskTypeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprTemplateRiskType.js